function isQuantityEditable(option) {
    return !!option.quantityEditable;
}
function isVisibleOption(option) {
    var _a;
    return Boolean((_a = option.item) === null || _a === void 0 ? void 0 : _a.id) && !option.hide;
}
function toUpsellSaleItemOption(option, included) {
    var _a, _b, _c;
    return {
        id: option.id,
        price: option.price,
        quantity: option.quantity,
        proposed: !included,
        included,
        required: false,
        recommended: false,
        locked: false,
        quantityEditable: isQuantityEditable(option),
        order: (_a = option.order) !== null && _a !== void 0 ? _a : 0,
        item: option.item,
        relations: (_c = (_b = option.item) === null || _b === void 0 ? void 0 : _b.relations) !== null && _c !== void 0 ? _c : []
    };
}
/**
 * Builds a catalog-like sale item from a paid deal line so the store options
 * UI can offer remaining proposed extras, with already-owned options as
 * read-only context.
 */
export function dealItemToUpsellSaleItem(item) {
    var _a;
    const visible = ((_a = item.options) !== null && _a !== void 0 ? _a : []).filter(isVisibleOption);
    const remaining = visible.filter((option) => option.proposed && !option.included);
    if (remaining.length === 0 || !item.item) {
        return null;
    }
    const owned = visible.filter((option) => !option.proposed);
    const options = [
        ...owned.map((option) => toUpsellSaleItemOption(option, true)),
        ...remaining.map((option) => toUpsellSaleItemOption(option, false))
    ];
    return Object.assign(Object.assign({}, item.item), { price: 0, options });
}
export function upsellSelectionFromDeal(deal) {
    var _a;
    const pairs = ((_a = deal.items) !== null && _a !== void 0 ? _a : [])
        .map((item) => {
        const saleItem = dealItemToUpsellSaleItem(item);
        if (!saleItem) {
            return null;
        }
        return {
            saleItem,
            selectedItem: {
                id: saleItem.id,
                quantity: 1,
                selectedOptionIds: []
            },
            dealItemId: item.id
        };
    })
        .filter(Boolean);
    return {
        saleItems: pairs.map((entry) => entry.saleItem),
        selectedItems: pairs.map((entry) => entry.selectedItem)
    };
}
export function buildUpsellMutationOptions(deal, selectedItems) {
    var _a, _b, _c, _d, _e;
    const selectedByProduct = new Map(selectedItems.map((item) => [item.id, item]));
    const payload = [];
    for (const dealItem of (_a = deal.items) !== null && _a !== void 0 ? _a : []) {
        const productId = (_b = dealItem.item) === null || _b === void 0 ? void 0 : _b.id;
        if (!productId) {
            continue;
        }
        const selected = selectedByProduct.get(productId);
        for (const optionId of (_c = selected === null || selected === void 0 ? void 0 : selected.selectedOptionIds) !== null && _c !== void 0 ? _c : []) {
            const option = (_d = dealItem.options) === null || _d === void 0 ? void 0 : _d.find((entry) => { var _a; return ((_a = entry.item) === null || _a === void 0 ? void 0 : _a.id) === optionId; });
            const quantity = (_e = selected === null || selected === void 0 ? void 0 : selected.optionQuantities) === null || _e === void 0 ? void 0 : _e[optionId];
            payload.push(Object.assign({ item: dealItem.id, option: optionId }, (option && isQuantityEditable(option) && quantity != null
                ? { quantity }
                : {})));
        }
    }
    return payload;
}
export function dealForUpsellPaymentPreview(deal, selectedItems, paymentAmount) {
    var _a;
    const selectedByProduct = new Map(selectedItems.map((item) => [item.id, item]));
    const items = ((_a = deal.items) !== null && _a !== void 0 ? _a : [])
        .map((item) => {
        var _a, _b, _c, _d, _e;
        const selected = selectedByProduct.get((_b = (_a = item.item) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '');
        const selectedIds = new Set((_c = selected === null || selected === void 0 ? void 0 : selected.selectedOptionIds) !== null && _c !== void 0 ? _c : []);
        const extras = (_e = (_d = item.options) === null || _d === void 0 ? void 0 : _d.filter((option) => { var _a; return ((_a = option.item) === null || _a === void 0 ? void 0 : _a.id) != null && selectedIds.has(option.item.id); })) !== null && _e !== void 0 ? _e : [];
        if (extras.length === 0) {
            return null;
        }
        return Object.assign(Object.assign({}, item), { price: 0, options: extras.map((option) => {
                var _a, _b;
                return (Object.assign(Object.assign({}, option), { proposed: false, quantity: isQuantityEditable(option)
                        ? ((_b = (_a = selected === null || selected === void 0 ? void 0 : selected.optionQuantities) === null || _a === void 0 ? void 0 : _a[option.item.id]) !== null && _b !== void 0 ? _b : option.quantity)
                        : option.quantity }));
            }) });
    })
        .filter(Boolean);
    return Object.assign(Object.assign({}, deal), { total: paymentAmount, subtotal: paymentAmount, taxes: 0, items });
}
